import React from 'react';
import PropTypes from 'prop-types';

import Logo from '../assets/logos/logo';

import './LoadingPage.css';

const LoadingPage = ({ isLoading, error }) => {
  if (isLoading) {
    return (
      <div className="LoadingPage">
        <Logo medium spin className="loader" />
      </div>
    );
  }
  if (error) {
    return <div className="LoadingPageProblem"><h3>Sorry, there was a problem loading the page.</h3></div>;
  }
  return null;
};

LoadingPage.propTypes = {
  isLoading: PropTypes.bool,
  error: PropTypes.string,
};

LoadingPage.defaultProps = {
  isLoading: false,
  error: null,
};

export default LoadingPage;



// WEBPACK FOOTER //
// ./src/components/LoadingPage.jsx